// Original gist: https://gist.github.com/2881585

(function ( $ ) {

  $.fn.removeClassByPrefix = function (prefix) {

    $(this).each( function ( index, item ) {

      var elmItem = $(item);
      var data = elmItem.attr('class') || '';
      var classes = data.split(" ");

      var filteredClasses = _.compact(_.map(classes, function (cl) {
         return cl.indexOf(prefix) === 0 ? "" : cl;
      }));

      elmItem.attr('class', filteredClasses.join(" ") );

    });

    return this;
  };

})( jQuery );

define("lib/jquery/jquery.removeClassByPrefix", ["jquery"], function(){});

